import { render, staticRenderFns } from "./VariantPickerModal.vue?vue&type=template&id=6b8bc45c&scoped=true"
import script from "./VariantPickerModal.vue?vue&type=script&lang=js"
export * from "./VariantPickerModal.vue?vue&type=script&lang=js"
import style0 from "./VariantPickerModal.vue?vue&type=style&index=0&id=6b8bc45c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8bc45c",
  null
  
)

export default component.exports